import settings from '@/settings'

let list = (headers, data) => {
  let url = `${settings.apetrusApi}/veiculos/poradmin/`
  if (data) {
    Object.keys(data).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data[filter]}`
    })
  }
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

let editar = (headers, data) => {
  let url = `${settings.apetrusApi}/veiculos/editar/`
  if (data.projeto === 'conecta_revendas') {
    url = `${settings.conectaRevendasApi}/veiculos/editar/`
  }
  return fetch(url, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

const opcionais = (headers, data) => {
  const request = {
    method: data.method,
    mode: 'cors',
    headers: headers
  }

  let url = `${settings.apetrusApi}/veiculos/opcionais/${data.id ? `${data.id}/` : ''}`
  if (data.parametros) {
    Object.keys(data.parametros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parametros[filter]}`
    })
  }

  if (data.method === 'GET') {
    request.cache = 'default'
  } else request.body = JSON.stringify(data.body)

  return fetch(url, request)
}

export default {
  list,
  editar,
  opcionais
}
